import styled from "styled-components";

// styles
export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  height: 58px;
  .img {
    border-radius: 50%;
    object-fit: cover;
  }
  .column-flex {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 80%;
  }
  .specialties {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 400;
    color: rgba(117, 117, 117, 1);
    margin: 0 !important;
  }
  .name {
    font-size: 15px;
    font-weight: 500;
    color: rgba(65, 65, 65, 1);
    line-height: 36px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 !important;
  }
`;

export const HPWrapper = styled.div`
  display: block;
  width: auto;
  height: 50px;
  border-radius: 8px;
  cursor: pointer;
  line-height: 50px;
  border: 1px solid white;
  padding: 0 10px !important;
  @media (max-width: 700px) {
    padding: 0 !important;
  }
  .text {
    text-align: center;
    color: #0d2439;
    font-size: 14px;
    font-weight: 500;
  }
  ${(p) =>
    p.borderColor &&
    `
        border-color: ${p.borderColor};
    `}
  ${(p) =>
    p.id === "clinic-info" &&
    `
        height: auto;
        border-radius: 0px;
        padding: 0 16px;
        .text {
            font-size: 15px;
            font-weight: 550;
            margin: 0 !important;
            margin-bottom: 7px !important;
        }
    `}
    ${(p) =>
    p.id === "clinic-info" &&
    p.selected &&
    `
        border-bottom: 2px solid rgb(69, 144, 144);
        .text {
            color: rgb(69, 144, 144);
        }
    `}
    ${(p) =>
    p.id !== "clinic-info" &&
    p.selected &&
    `
        border: 1px solid #29BCAB;
    `}
`;

export const PostWrapper = styled.div`
  width: 33.33%;
  padding: 16px;
  box-sizing: border-box;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #ccc;

  .banner {
    border-radius: 8px;
    object-fit: cover;
    width: 100%;
    height: auto;
  }

  .title {
    font-size: 18px;
    font-weight: 700;
    margin-top: 16px;
    text-align: center;
  }

  .subtitle {
    font-size: 14px;
    color: #555;
    text-align: center;
    margin-top: 8px;
  }

  @media (max-width: 768px) {
    width: 100%; /* Stack posts on mobile */
    margin-bottom: 16px;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row !important;
  align-items: flex-start;
  gap: 25px;
  margin-top: 80px;
  height: auto;
  margin-bottom: 30px;
  @media (max-width: 900px) {
    flex-direction: column;
  }
  div {
    ${(p) =>
      p.webConfig.dir === "ltr" &&
      `
		    direction: ltr !important;
		    text-align: left;
	`}
  }
  .fixed-button {
    @media (min-width: 901px) {
      display: none;
    }
    position: fixed;
    bottom: 105px;
    left: 0;
    width: 100%;
    background: white;
    padding: 16px;
    box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.2);
    z-index: 999;
    cursor: pointer;
    ${(p) =>
      p.appPromptClose &&
      `
            bottom: 50px;
        `}
    ${(p) =>
      !p.isMobile &&
      `
            bottom: 50px;
        `}
        .button {
      width: 100%;
      height: 42px;
    }
  }
  .first-column {
    width: calc(100% - 411px);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    @media (max-width: 900px) {
      width: 100%;
    }
  }
  .second-column {
    position: absolute;
    width: 386px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    ${(p) =>
      p.webConfig.dir === "ltr"
        ? `
            right: 0;
        `
        : `
            left: 0;
        `}
    @media (max-width: 900px) {
      display: none;
    }
  }
  .is-sticky {
    position: fixed;
    width: 386px;
    top: 78px;
    z-index: 999;
    animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;
    ${(p) =>
      p.webConfig.dir === "ltr"
        ? `
            right: 112px;

        `
        : `
            left: 112px;

        `}
    @media (max-width: 1400px) {
      ${(p) =>
        p.webConfig.dir === "ltr"
          ? `
                right: 70px;
            `
          : `
                left: 70px;
            `}
    }
    @media (max-width: 1200px) {
      ${(p) =>
        p.webConfig.dir === "ltr"
          ? `
                right: 40px;
            `
          : `
                left: 40px;
            `}
    }
    @media (max-width: 1000px) {
      ${(p) =>
        p.webConfig.dir === "ltr"
          ? `
                right: 30px;
            `
          : `
                left: 30px;
            `}
    }
    @media (max-width: 900px) {
      ${(p) =>
        p.webConfig.dir === "ltr"
          ? `
                right: 20px;
            `
          : `
                left: 20px;
            `}
    }
  }
  .is-fixed {
    position: absolute;
    top: auto;
    bottom: 0;
    z-index: 0;
    animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;
    ${(p) =>
      p.webConfig.dir === "ltr"
        ? `
            right: 0;
        `
        : `
            left: 0;
        `}
  }
  .box {
    width: 100%;
    background: #fff;
    border-radius: 16px;
    height: auto;
    padding: 0 24px;
    padding-bottom: 24px;
    .margin-1 {
      margin: -1px 0;
    }
    .name {
      font-weight: 700;
      font-size: 24px;
    }
    .doctor-image {
      width: 106px;
      height: 106px;
      border-radius: 50%;
      margin-top: -55px;
      margin-left: 24px;
      background: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      ${(p) =>
        p.webConfig.dir === "ltr" &&
        `
                margin-left: 0px;
	        `}
      .img {
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .content {
      width: 100%;
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      margin-top: 10px;
      @media (max-width: 800px) {
        margin-top: 20px;
      }
    }
    .flex-start {
      align-items: flex-start;
      justify-content: flex-start;
      gap: 15px;
    }
    .title {
      font-size: 18px;
      font-weight: 700;
      @media (max-width: 600px) {
        font-size: 19px;
      }
    }
    .list {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      width: 100%;
      gap: 5px;
      .item {
        width: 100%;
      }
      .gap-5 {
        flex-wrap: wrap;
      }
    }

    .view-button {
      display: flex;
      flex-direction: row;
      gap: 5px;
      align-items: center;
      justify-content: center;
      color: rgb(69, 144, 144);
      font-size: 13px;
      font-weight: 500;
      .label {
        color: rgb(69, 144, 144);
        font-size: 13px;
        font-weight: 500;
      }
      .icon {
        width: 13px;
        height: 13px;
        color: rgb(69, 144, 144);
      }
    }
    .carousel {
      margin-top: 20px;
    }
    .clinics {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      gap: 0px;
    }
    .clinic-info {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 8px;
      &:nth-of-type(2) {
        margin-top: -15px;
      }
      @media (max-width: 800px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 0 !important;
        &:nth-of-type(2) {
          margin-top: 0;
        }
        .value {
          margin-top: 5px;
        }
      }
    }
    .row-flex {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      gap: 15px;
    }
    .space-between {
      justify-content: space-between;
      width: 100%;
    }
    .gap-5 {
      gap: 5px;
    }
    .gap-8 {
      gap: 8px;
      @media (max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
      }
    }
    .gap-8-center {
      gap: 8px;
      justify-content: center;
    }
    .label {
      color: #61788e;
      font-size: 14px;
      font-weight: 500;
    }
    .value {
      color: #0d2439;
      font-size: 15px;
      font-weight: 500;
      line-height: 28px;
    }
    .filled-circle {
      background: #61788e;
      display: block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
    }
    .blog-link {
      color: black;
      font-size: 14px;
      font-weight: 500;
    }
    .arrow-left {
      color: black;
      width: 14px;
      height: 14px;
    }
    .posts-mobile {
      display: none;
      @media (max-width: 768px) {
        display: block; /* Show on mobile screens */
      }
    }
    .posts {
      display: flex;
      flex-direction: row; /* This ensures posts are in a row on large screens */
      justify-content: space-between;
      gap: 16px; /* Adjust space between posts */
      margin-bottom: 20px;
    }

    .time {
      border: 1px solid #cccccc;
      border-radius: 8px;
      width: 33.33%;
      height: 64px;
      padding: 8px;
    }
    .marginT-8 {
      margin-top: 8px;
    }
  }

  .column-flex {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
    .box {
      width: 100%;
      background: #fff;
      border-radius: 8px;
      height: auto;
    }
    .padding-16 {
      padding: 16px;
    }
    .padding-0 {
      padding: 0;
    }
    .padding-y-0 {
      padding-top: 0px;
      padding-bottom: 0px;
    }
    .row-flex {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }
  }
`;
